import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledInput, StyledSearchInputContainer } from "app/pages/sales-intelligence/common-components/SearchTextBox";

export const StyledSearchBoxContainer = styled.div<{ isDisabled: boolean }>`
    background-color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.bluegrey["200"] : colorsPalettes.carbon["0"])};
    flex-grow: 1;
    position: sticky;
    padding: 12px 18px;
    top: 106px;
    z-index: 2;

    & ${StyledSearchInputContainer} ${StyledInput} {
        height: 30px;
    }
`;
